var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "commissions-fees-wrapper" }, [
    _c(
      "div",
      { staticClass: "commissions-fees-header py-4 column-divider-bottom" },
      [
        _c(
          "b-row",
          { staticClass: "align-items-end" },
          _vm._l(_vm.columnHeaders, function (columnHeader, index) {
            return _c(
              "div",
              { key: "column-header-" + index, class: columnHeader.size },
              [
                _c(
                  "h6",
                  {
                    staticClass:
                      "theader theader-big m-0 cursor-auto text-left text-lg-center d-none d-lg-block text-light-gray",
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(columnHeader.label) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  {
                    staticClass:
                      "theader theader-big m-0 cursor-auto text-left text-lg-center d-lg-none d-block text-light-gray",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(columnHeader.shortLabel || columnHeader.label) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "commissions-fees-body p-4" },
      [
        _vm.loading
          ? _c("fees-loader")
          : _c(
              "div",
              _vm._l(_vm.commissionsFees, function (fee, index) {
                return _c("commission-fee", {
                  key: fee.feeType + "-" + index,
                  attrs: {
                    fee: fee,
                    "funded-amount": _vm.fundedAmount,
                    "expanded-grid": _vm.anyFeeWithOther,
                    saving: _vm.currentFeeIsSaving(fee),
                    "is-read-only": _vm.isReadOnly,
                  },
                  on: {
                    remove: function ($event) {
                      return _vm.handleRemoveFee(fee.commissionsFeeId)
                    },
                    change: _vm.handleChange,
                  },
                })
              }),
              1
            ),
        _vm._v(" "),
        _vm.addingFee
          ? _c("fee-loader")
          : _c(
              "div",
              { staticClass: "d-flex flex-row justify-content-start mt-2" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn clickable text-primary bold bs-0 px-0 btn-transparent",
                    attrs: { disabled: _vm.isReadOnly },
                    on: { click: _vm.handleAddFee },
                  },
                  [
                    _vm._v(
                      "\n        + " +
                        _vm._s(
                          _vm.$t("direct-to-lender.commissions.fees.addFee")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }